export const GeneralBottomSheet = () => {
    throw new Error("GeneralBottomSheet is not supported under a web configuration");
};
export const BottomSheetProvider = () => {
    throw new Error("BottomSheetProvider is not supported under a web configuration");
};
export const SheetHeader = () => {
    throw new Error("SheetHeader is not supported under a web configuration");
};
